<template>
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <!-- <v-btn class="success" v-on="on"> -->
      <v-icon
        left
        v-on="on"
        small
        title="View"
        color="success"
        @click="fetchTeamMembers"
      >
        visibility
      </v-icon>
      <!-- </v-btn> -->
    </template>
    <v-card>
      <!-- <v-card-title>
        <v-icon left>group</v-icon>
        <span class="headline">Team Details</span>
      </v-card-title> -->
      <v-toolbar>
        <v-toolbar-title>
          <v-icon left>group</v-icon>
          Team Details
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon large color="error">close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- <pre>{{ teamMembers }}</pre> -->
      <v-card-text class="py-0">
        <v-container grid-list-sm>
          <v-layout align-center justify-space-between row fill-height>
            <v-flex sm9>
              <h1>{{ teamDetails.team_name }}</h1>
              <br />
              <v-layout>
                <v-flex sm3><h3>Team ID</h3></v-flex>
                <v-flex sm3><h3>Code</h3></v-flex>
                <v-flex sm3><h3>Number of Members</h3></v-flex>
              </v-layout>
              <v-layout class="mt-2">
                <v-flex sm3>
                  <p>
                    {{ teamDetails.id }}
                  </p>
                </v-flex>
                <v-flex sm3>
                  <div class="d-inline-flex">
                    {{ teamDetails.team_code }}
                    <CopyToClickboard :text="teamDetails.team_code" />
                  </div>
                </v-flex>
                <v-flex sm3>
                  <p>
                    <span title="Available">
                      {{ teamDetails.team_response_count }}
                    </span>
                    |
                    <span title="Max Members">
                      {{ teamDetails.numbers_of_dasher }}
                    </span>
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm3>
              <div class="text-xs-right">
                <AddTeamMemberDialog
                  :team_code="teamDetails.team_code"
                  @result="showMessage"
                />
              </div>
            </v-flex>
          </v-layout>
          <br />
          <v-layout>
            <v-flex sm12>
              <v-card class="pa-2">
                <v-tabs v-model="active" slider-color="#f66">
                  <v-tab class="pl-3">
                    Active ({{
                      teamMembers.filter(
                        (member) =>
                          member.active_status === 1 &&
                          member.verification_status === 1
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Inactive ({{
                      teamMembers.filter((member) => member.active_status === 0)
                        .length
                    }})
                  </v-tab>
                  <v-tab>
                    Pending ({{
                      teamMembers.filter(
                        (member) =>
                          member.dasher_agreement === 1 &&
                          member.verification_status === 0
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Awaiting Approval ({{
                      teamMembers.filter(
                        (member) =>
                          member.dasher_agreement === 0 &&
                          member.verification_status === 1
                      ).length
                    }})
                  </v-tab>
                  <v-tab>
                    Rejected ({{
                      teamMembers.filter(
                        (member) => member.verification_status === 2
                      ).length
                    }})
                  </v-tab>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseTeam
                      :loading="loading"
                      :teamMembers="
                        teamMembers.filter(
                          (member) =>
                            member.active_status === 1 &&
                            member.verification_status === 1
                        )
                      "
                      status="active"
                      @refetch="fetchTeamMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseTeam
                      :loading="loading"
                      :teamMembers="
                        teamMembers.filter(
                          (member) => member.active_status === 0
                        )
                      "
                      status="inactive"
                      @refetch="fetchTeamMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseTeam
                      :loading="loading"
                      :teamMembers="
                        teamMembers.filter(
                          (member) =>
                            member.dasher_agreement === 1 &&
                            member.verification_status === 0
                        )
                      "
                      status="pending"
                      @refetch="fetchTeamMembers"
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseTeam
                      :loading="loading"
                      :teamMembers="
                        teamMembers.filter(
                          (member) =>
                            member.dasher_agreement === 0 &&
                            member.verification_status === 1
                        )
                      "
                    />
                  </v-tab-item>
                  <v-tab-item class="px-4 pb-4">
                    <StatuswiseTeam
                      :loading="loading"
                      :teamMembers="
                        teamMembers.filter(
                          (member) => member.verification_status === 2
                        )
                      "
                    />
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ message }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  import AddTeamMemberDialog from "./AddTeamMemberDialog";
  import StatuswiseTeam from "./StatuswiseTeam";
  import CopyToClickboard from "../CopyToClickboard";
  export default {
    components: { AddTeamMemberDialog, StatuswiseTeam, CopyToClickboard },
    props: ["teamDetails"],
    data() {
      return {
        loading: false,
        dialog: false,
        active: 0,
        newTeam: null,
        teamMembers: [],
        color: "",
        message: "",
        snackbar: false,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.initialize();
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      async initialize() {
        this.newTeam = { ...this.teamDetails };
      },
      async fetchTeamMembers() {
        this.loading = true;
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            `team-response-status/${this.newTeam.id}`
          );
          this.teamMembers = data.data.teamMembers;
        } catch (error) {
          //
        }
        this.loading = false;
      },
      close() {
        this.dialog = false;
      },
      showMessage(event) {
        this.color = event[1];
        this.message = event[0];
        this.snackbar = true;
        if (this.color == "success") {
          this.fetchTeamMembers();
          this.active = 3;
        }
      },
    },
  };
</script>
